import React, { useState, useEffect } from "react";
import "./Restaurent.css";
import Filter from "./Filter";
import Hotels from "./Hotels";
import { Link } from "react-router-dom";

const Restaurent = () => {
  // const [restaurentData, setRestaurentData] = useState([]);

  // const Api_key = "09a6f6ea147d4b04bd8cd9dcb1a928e9";
  // const api_id = '682718c9'
  

  // useEffect(() => {
  //   fetchRestaurantData();
  // }, []);

  // const fetchRestaurantData = async () => {
  //   try {
  //     const response = await fetch(`https://api.spoonacular.com/food/restaurants/search?cuisine=italian?lat=34.7786357?lon=-122.3918135?apiKey=${Api_key}`)
  //     const data = await response.json();
  //     setRestaurentData(data);
  //     console.log(data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  return (
    <>
      <div className="container-fluid collection">
        <div className="container heading-restaurent">
          <h2 className="title-restaurent pt-4 pb-3">Collections</h2>
        </div>
        <div className="container collection-content">
        <p className=" para-restaurent">Explore curated lists of top restaurants, cafes, pubs, and bars in Ahmedabad, based on trends</p>
        <span ><Link className="all-collection " to='/collections'>All the Collections of Restaurents→</Link></span>
        </div>
        <div className="container wrapper-box-collection">
          <div className="row">
            <div className="col-4 box-collection box-1">
              <div className="content">
                <h5>Newly open restaurent</h5>
                <p className="para-collection">7 places →</p>
              </div>
            </div>
            <div className="col-4 box-collection box-2">

              <div className="content">
                <h5>Newly open restaurent</h5>
                <p className="para-collection">7 places →</p>
              </div>
            </div>
             <div className="col-4 box-collection box-3">

              <div className="content">
                <h5>Newly open restaurent</h5>
                <p className="para-collection">7 places →</p>
              </div>
            </div> <div className="col-4 box-collection box-4 ">

              <div className="content">
                <h5>Newly open restaurent</h5>
                <p className="para-collection">7 places →</p>
              </div>
            </div>
          </div>
        </div>
      </div>
        <Filter />
        <div className="container">
        <div className="img-dining">
           <img className="img-dining-res" src="https://b.zmtcdn.com/data/o2_assets/da94405b04f6ae6bf64a4e2a01b1b5c11686563732.png" alt="" srcset="" /> 
        </div>
        </div>
      <Hotels />

    </>
  );
};

export default Restaurent;
